<app-plans-chooser
  (select)="handlePlanSelect($event)"
  [pending]="pending"
></app-plans-chooser>
